import { render, staticRenderFns } from "./CreatorLeadboardPage.vue?vue&type=template&id=71c6dca6&"
import script from "./CreatorLeadboardPage.vue?vue&type=script&lang=js&"
export * from "./CreatorLeadboardPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports